(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/games/assets/javascripts/helpers/get-sold-fractions-count.js') >= 0) return;  svs.modules.push('/components/marketplace-data/games/assets/javascripts/helpers/get-sold-fractions-count.js');
"use strict";


const getSoldFractionsCount = fractions => Object.keys(fractions).reduce((total, key) => total + fractions[key], 0);
setGlobal('svs.components.marketplaceData.games.helpers.getSoldFractionsCount', getSoldFractionsCount);

 })(window);